import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _createClass from '@babel/runtime/helpers/createClass';
import _possibleConstructorReturn from '@babel/runtime/helpers/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/getPrototypeOf';
import _inherits from '@babel/runtime/helpers/inherits';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import escapeStringRegexp from 'escape-string-regexp';
import classnames from 'classnames';
import noop from 'no-op';

var Autocomplete =
/*#__PURE__*/
function (_Component) {
  _inherits(Autocomplete, _Component);

  function Autocomplete() {
    var _getPrototypeOf2;

    var _temp, _this;

    _classCallCheck(this, Autocomplete);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Autocomplete)).call.apply(_getPrototypeOf2, [this].concat(args))), _this.state = {
      value: _this.props.value,
      cursor: 0,
      open: false,
      hover: false,
      placeholder: _this.props.placeholder
    }, _this.handleInput = function (e) {
      var value = e.target.value;

      _this.setValue({
        value: value,
        select: false
      });
    }, _this.handleClick = function (e) {
      if (!e.target.matches('li')) return;
      var value = e.target.textContent;

      _this.setValue({
        value: value,
        select: true
      });
    }, _this.handleKeyDown = function (event) {
      if (event.keyCode === 38) {
        _this.up();
      } else if (event.keyCode === 40) {
        _this.down();
      } else if (event.keyCode === 13) {
        _this.select();
      }
    }, _this.saveList = function (ul) {
      _this.ul = ul;
    }, _this.handleFocus = function () {
      _this.setState({
        open: true
      });
    }, _this.handleBlur = function () {
      if (!_this.state.hover && _this.state.open) {
        _this.setState({
          open: false
        });
      }
    }, _this.handleMouseEnter = function () {
      _this.setState({
        hover: true
      });
    }, _this.handleMouseLeave = function () {
      _this.setState({
        hover: false
      });
    }, _temp));
  }

  _createClass(Autocomplete, [{
    key: "setValue",
    value: function setValue(_ref) {
      var value = _ref.value,
          select = _ref.select;
      this.setState({
        value: value,
        cursor: 0,
        open: !select
      });
      this.props.onChange(value);

      if (select) {
        this.props.onSelect(value);
      }
    }
  }, {
    key: "isOpen",
    value: function isOpen() {
      return this.state.open && this.ul;
    }
  }, {
    key: "down",
    value: function down() {
      var cursor = this.state.cursor;

      if (this.isOpen()) {
        this.setState({
          cursor: (cursor + 1) % this.length
        });
      }
    }
  }, {
    key: "up",
    value: function up() {
      var cursor = this.state.cursor;

      if (this.isOpen()) {
        this.setState({
          cursor: (cursor - 1 + this.length) % this.length
        });
      }
    }
  }, {
    key: "select",
    value: function select() {
      var cursor = this.state.cursor;

      if (this.ul) {
        var value = this.ul.childNodes[cursor].textContent;
        this.setValue({
          value: value,
          select: true
        });
      }
    }
  }, {
    key: "cursorInView",
    value: function cursorInView() {
      var cursor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state.cursor;

      if (this.isOpen()) {
        var _this$ul = this.ul,
            clientHeight = _this$ul.clientHeight,
            scrollTop = _this$ul.scrollTop;
        var _this$ul$childNodes$c = this.ul.childNodes[cursor],
            activeTop = _this$ul$childNodes$c.offsetTop,
            childHeight = _this$ul$childNodes$c.offsetHeight;
        return activeTop >= scrollTop && Math.round(activeTop + childHeight - (scrollTop + clientHeight)) <= 0;
      }

      return false;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var cursor = this.state.cursor;

      if (prevState.cursor !== cursor && this.isOpen() && !this.cursorInView(cursor)) {
        var clientHeight = this.ul.clientHeight;
        var node = this.ul.childNodes[cursor];
        var offsetTop = node.offsetTop;

        if (prevState.cursor < cursor) {
          var offsetHeight = node.offsetHeight;
          this.ul.scrollTop = offsetTop - clientHeight + offsetHeight;
        } else {
          this.ul.scrollTop = offsetTop;
        }
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.placeholder !== this.props.placeholder) {
        this.setState({
          placeholder: nextProps.placeholder
        });
      }

      if (nextProps.value !== this.props.value) {
        this.setState({
          value: nextProps.value,
          cursor: 0
        });
      }
    }
  }, {
    key: "renderList",
    value: function renderList() {
      var _classnames;

      var _this$state = this.state,
          value = _this$state.value,
          cursor = _this$state.cursor;
      var _this$props = this.props,
          prefixCls = _this$props.prefixCls,
          dataSource = _this$props.dataSource;
      var regex = new RegExp(escapeStringRegexp(String(value)), 'i');
      var items = dataSource.filter(function (x) {
        return regex.test(x);
      });
      this.length = items.length;
      var ulClasses = classnames((_classnames = {}, _defineProperty(_classnames, "".concat(prefixCls, "autocomplete__list"), true), _defineProperty(_classnames, "".concat(prefixCls, "autocomplete__list--hidden"), !this.state.open || this.length <= 0), _classnames));
      var itemCls = "".concat(prefixCls, "autocomplete__item");
      var itemActiveCls = "".concat(itemCls, " ").concat(prefixCls, "autocomplete__item--active");
      return React.createElement("ul", {
        ref: this.saveList,
        onClick: this.handleClick,
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseLeave,
        className: ulClasses
      }, items.map(function (item, index) {
        return React.createElement("li", {
          key: index,
          className: index === cursor ? itemActiveCls : itemCls
        }, item);
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _classnames2;

      var _this$state2 = this.state,
          value = _this$state2.value,
          placeholder = _this$state2.placeholder;
      var _this$props2 = this.props,
          prefixCls = _this$props2.prefixCls,
          className = _this$props2.className;
      var cls = classnames((_classnames2 = {}, _defineProperty(_classnames2, "".concat(prefixCls, "autocomplete"), true), _defineProperty(_classnames2, "className", Boolean(className)), _classnames2));
      return React.createElement("div", {
        className: cls
      }, React.createElement("input", {
        type: "search",
        value: value,
        placeholder: placeholder,
        onInput: this.handleInput,
        onKeyDown: this.handleKeyDown,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        className: "".concat(prefixCls, "autocomplete__input")
      }), this.renderList());
    }
  }]);

  return Autocomplete;
}(Component);

Autocomplete.defaultProps = {
  onChange: noop,
  onSelect: noop,
  value: '',
  placeholder: '',
  prefixCls: '',
  className: ''
};
Autocomplete.propTypes = {
  dataSource: PropTypes.array.isRequired,
  onChange: PropTypes.func,
  onSelect: PropTypes.func,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  prefixCls: PropTypes.string,
  className: PropTypes.string
};

export default Autocomplete;
//# sourceMappingURL=index.m.js.map
